// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__avHRY","sendOtp":"AuthorizeToLogin_sendOtp__1MBlg"};